/**
 * Formats a number to ensure it has at most two decimal places.
 * @param {number} value - The number to be formatted.
 * @returns {number} - The formatted number.
 */
export const numberTwoDecimal = (value: number): number => {
	const decimalCount = (value?.toString().split('.')[1] || '').length;

	if (decimalCount <= 2) {
		return value;
	}

	return parseFloat(value.toFixed(2));
};

/**
 * Converts an unknown value to a finite number.
 * If the conversion results in a non-finite number (NaN, Infinity, -Infinity),
 * it returns 0.
 * @param {unknown} value - The value to be converted.
 * @returns {number} - The converted finite number or 0.
 */
export const toNumber = (value: unknown): number => {
	const n = typeof value === 'number' ? value : Number(value);
	return Number.isFinite(n) ? n : 0;
};
